<template>
    <span>
        <slot name="before-button"/>
        <b-button v-b-tooltip.noninteractive.hover.top="Tooltip"
                  :class="ButtonInsideClass"
                  class="btn-circle"
                  :disabled="(FeatureName != '' &&  Action != '' ? !$store.getters['CheckAction'](Right, FeatureName, Action): true) && Disabled"
                  :title="Tooltip ? Tooltip : parameters?.Tooltip"
                  :variant="Variant"
                  v-on="$listeners">
            <slot name="before-label"/>
            <span :class="ContentClass" v-html="$t(Label)"/>
            <slot name="after-label"/>
        </b-button>
        <slot name="after-button"/>
    </span>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import ButtonLabel from "../ButtonLabel";
import ButtonIconComplexe from "@/components/commons/Generics/GenericButton/Button/ButtonIcon/ButtonIconComplexe.vue";

@Component({
    components: {ButtonIconComplexe},
    i18n: ButtonLabel.MessageLocales()
})
export default class ButtonLabelComplex extends ButtonLabel {
    constructor() {
        super();
    }
}
</script>

<style scoped>

</style>